export default __webpack_public_path__ + "static/media/11.5d74dbe1.webp";